import Blamable        from '@/models/traits/Blamable';
import MapServiceModel from '@/models/MapServiceModel';
import ProjectModel    from '@models/map/ProjectModel';
import TimestampAble   from '@widesk-core/models/traits/TimestampAble';
import doc             from '@widesk-core/decorators/doc';
import model           from '@widesk-core/decorators/model';
import { computed }    from 'mobx';

/**
 * Une publication : elle porte le projet, une version de schéma commune à toutes ses cartes, et le
 * fichier condensé qui regroupe les cartes compilées.
 *
 * Le `POST` ne rend PAS une publication terminée : il enregistre la demande et rend la main, un
 * consumer crée ensuite chaque `MapVersion` puis assemble le fichier. `fileUrl` est le seul témoin
 * d'achèvement (voir `isPublished`) — tant qu'elle est vide, la route publique du projet répond
 * encore avec des cartes vides.
 */
@model.urnResource('project_version')
@doc.path('/project_versions/{?id}')
export default class ProjectVersionModel extends Blamable(TimestampAble(MapServiceModel)) {
	private declare _tsFilters: {
		'createdAt': string;
		'project': id;
		'project.owner.accountUrn': string;
		'updatedAt': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'number': string;
		'updatedAt': string;
	};

	@doc.string declare comment: string;
	/** Urn du fichier condensé du projet ; vide tant que la publication n'est pas achevée. */
	@doc.string declare fileUrl: string;
	@doc.number declare jsonSchemaVersion: number;
	@doc.number declare number: number;
	@doc.model(ProjectModel) declare project: ProjectModel;

	/** Publication achevée : le fichier condensé existe, la route publique du projet le sert. */
	@computed get isPublished() {
		return !!this.get('fileUrl');
	}

	/** Le back numérote à partir de 0 ; on affiche à partir de 1. */
	@computed get displayNumber() {
		return this.number + 1;
	}
}
